import { HttpStatusCode } from "axios";
import { client } from "../client";
import type {
	AnnouncementType,
	Announcement,
} from "../types/announcement.types";
import type { Paginated, PaginatedFilter } from "../types/axios.types";

export const fetchAnnouncement = async (type: AnnouncementType) => {
	const response = await client.get<Announcement>(`announcement/${type}`);
	if (response.status === HttpStatusCode.NoContent) {
		return null;
	}
	return response.data;
};

export const fetchAnnouncements = async (
	page?: number,
	size?: number,
	search?: string,
	filters?: PaginatedFilter,
	sortBy?: string[],
) => {
	const params = new URLSearchParams();
	// Pagination
	params.append("page", page ? page.toString() : "1");
	params.append("size", size ? size.toString() : "25");
	// Search
	if (search) {
		params.append("search", search);
	}
	// Sort
	if (sortBy) {
		sortBy.forEach((key) => params.append("sort", key));
	}
	// Filters
	if (filters) {
		Object.keys(filters).forEach((key: string) => {
			// Blacklist some keys
			if (
				["page", "size", "search", "sort"].includes(key) ||
				filters[key] === ""
			) {
				return;
			}
			params.append(
				key,
				Array.isArray(filters[key]) ? filters[key].join(",") : filters[key],
			);
		});
	}
	// Query
	const response = await client.get<Paginated<Announcement[]>>(
		`announcements`,
		{
			params,
		},
	);
	return response.data;
};
